<template>
	<EMCoreTemplate category="OSMLife" identity="policyFund" entity="osm_policy_fund"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/PolicyFund.vue